import Badge from "./Badge";

export default function BadgeHolder(props) {

    const content = {
        badge: [{
            naslov: "SPP",
            opis: "Po anketi liječnika najbolji medicinski i bolnički informatički sustav u Hrvatskoj",
            icon: "bi-h-square",
            link: "/SPP"
        },
        {
            naslov: "Registar bolesnika",
            opis: "Registar bolesnika omogućava prikupljanje i obradu medicinskih podataka",
            icon: "bi-people",
            link: "/Registar"
        },
        {
            naslov: "SMS gateway",
            opis: "Uređaj i API za razmjenu SMS poruka",
            icon: "bi bi-envelope-plus",
            link: "/SMSgateway"
        },
        {
            naslov: "RFID/NFC čitač kartica",
            opis: "Uređaj i API za čitanje RFID kartica",
            icon: "bi bi-card-heading",
            link: "/RFIDCardReader"
        },
        {
            naslov: "DL2",
            opis: "Registrator prisutnosti na radu sustav evidencije ulazaka i izlazaka pomoću beskontaktnih (RFID) kartica",
            icon: "bi-wifi",
            link: "/DL2"
        }
            ,
        {
            naslov: "GR1",
            opis: "Registrator prisutnosti na radu sustav evidencije ulazaka i izlazaka pomoću beskontaktnih i kontaktnih ''smart'' kartica",
            icon: "bi-person-vcard",
            link: "/GR1"
        }
        ]
    }

    const naslov = props.title || "Naši ostali proizvodi";

    const badges = content.badge.map((badge) => {
        if (badge.naslov.startsWith(props.skip)) return null;
        return <Badge icon={badge.icon} naslov={badge.naslov} opis={badge.opis} key={badge.key} link={badge.link} />

    })

    return (
        <section className="features-icons bg-light text-center">
            <div className="container">
                <div className="row">
                    <h1>{naslov}</h1>
                    {badges}
                </div>
            </div>
        </section>
    )
}